import './App.css';
import Main from './components/main/Main';
import Questions from './components/questions/Questions';


function App() {
  return (
    <div className='mt-3'>
      <Main></Main>
      <Questions></Questions>
    </div>

  );
}

export default App;
